import styled from 'styled-components';

import StyledLink from '../../../components/StyledLink';

export const StyledStateLink = styled(StyledLink)<{
  checked: boolean;
  alignment: 'left' | 'center' | 'right' | 'full';
}>``;
